<template>
  <div id="grid-contacto">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn v-if="!contratoExpirado && btnHidden != true && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()" color="success" dark class="mb-2" @click="newContact()">Agregar</v-btn>
          </v-card-actions>
          <v-data-table :headers="headers" :items="contactos" :rows-per-page-items="rowsPerPageItems"
            class="elevation-1">
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nombres }}</td>
              <td class="text-xs-left">{{ props.item.apellidos }}</td>
              <td class="text-xs-left">{{ props.item.fono }}</td>
              <td class="text-xs-left">{{ props.item.correo }}</td>
              <v-btn depressed outline icon fab dark color="green darken-4" small title="Ver contacto"
                @click="viewContacto(props.item.id)">
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn v-if="!contratoExpirado && btnEdit != true && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()" class="text-xs-center" depressed outline icon fab dark color="primary" small
                title="Editar contacto" @click="editContacto(props.item.id)">
                <v-icon>open_in_new</v-icon>
              </v-btn>
              <v-btn v-if="!contratoExpirado && btnDelete != true && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()" class="text-xs-center" depressed outline icon fab dark
                color="red darken-4" small title="Eliminar contacto" @click="openDeleteDialog(props.item.id)">
                <v-icon>clear</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA CONTACTO -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <td>
              <v-btn class="btn-sigas" depressed outline icon fab dark color="green darken-4" small>
                <v-icon>remove_red_eye</v-icon> </v-btn>&nbsp;Ver contacto&nbsp;
            </td>
            <td v-if="!contratoExpirado && btnEdit != true && getCodigoPerfil() != 'LEC'">
              <v-btn class="btn-sigas" depressed outline icon fab dark color="primary" small>
                <v-icon>open_in_new</v-icon> </v-btn>&nbsp;Editar contacto&nbsp;
            </td>
            <td v-if="!contratoExpirado && btnDelete != true  && getCodigoPerfil() != 'LEC'">
              <v-btn class="btn-sigas" v-if="btnEdit != true " depressed outline icon fab dark color="red darken-4"
                small>
                <v-icon>clear</v-icon> </v-btn>&nbsp;Eliminar contacto
            </td>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <!-- dialogo    -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click="deleteContact()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo -->
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-contacto",
  components: {},
  props: {
    tipoContacto: "",
    tipeView: "",
    fechaFin: String,
  },
  data: () => ({
    btnHidden: false,
    btnEdit: false,
    btnDelete: false,
    contactos: [],
    show: false,
    loading: false,
    dialog: false,
    contactToDelete: "",
    gridContacto: false,
    rowsPerPageItems: [20],
    pagination: {
      rowsPerPage: 20,
    },
    headers: [
      {
        text: "Nombre",
        align: "left",
        sortable: false,
        value: "nombre",
      },
      { text: "Apellido", align: "left", sortable: false, value: "apellido" },
      { text: "Fono", align: "left", sortable: false, value: "fono" },
      { text: "E-mail", align: "left", sortable: false, value: "email" },
      { text: "Acciones", align: "left", sortable: false, value: "" },
    ],
    id: Number,
    editedIndex: -1,
    contratoId: "",
  }),

  computed: {
    contratoExpirado() {
      console.log("la fecha fin es: " + this.fechaFin + " y hoy es: " + new Date() + "");
      if (!this.fechaFin) return false;
      const hoy = new Date();
      const finContrato = new Date(this.fechaFin);
      return finContrato < hoy; // true si la fecha ya pasó
    },
    
  },
  watch: {},
  created() {
    if (
      this.contratoId === undefined ||
      this.contratoId == null ||
      this.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    }

    this.userlogged = this.$store.getters.userLogged.tipo;

    if (this.userlogged == "PROVEEDOR") {
      this.btnHidden = true;
      this.btnEdit = true;
      this.btnDelete = true;
    } else {
      this.btnHidden = false;
      this.btnEdit = false;
      this.btnDelete = false;
    }
  },
  mounted() {
    this.loadDataContactos();
  },

  methods: {
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.id === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      console.log("DEVODED USER:", user);
      return user.perfil.codigo
    },
    initialize() { },
    save() {
      if (this.editedIndex > -1) {
      }
      this.close();
    },

    viewContacto(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContactoRegistra",
          params: {
            contactoId: id,
            tipeView: "consulta",
            tipeContact: [this.tipoContacto],
          },
        });
      }, 1000);
    },
    newContact() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContactoRegistra",
          params: { tipeView: "crear", tipeContact: this.tipoContacto },
        });
      }, 1000);
    },
    editContacto(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ContactoRegistra",
          params: {
            contactoId: id,
            tipeView: "modifica",
            tipeContact: [this.tipoContacto],
          },
        });
      }, 1000);
    },
    async deleteContact() {
      await this.delete();
      this.reloadGrid();
    },
    async delete() {
      let idUserLogged = this.$store.getters.userLogged.id;
      return await axios
        .delete(
          "/contacto/delete/" +
          this.contactToDelete +
          "/contrato/" +
          idUserLogged +
          "/" +
          this.contratoId
        )
        .then(function (response) {
          response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    reloadGrid() {
      this.dialog = false;
      if (this.tipoContacto == "AGENCIA") {
        this.$parent.$parent.reloadAgenciaContact();
      }
      if (this.tipoContacto == "PROVEEDOR") {
        this.$parent.$parent.reloadProveedorContact();
      }
    },
    openDeleteDialog(contact) {
      this.contactToDelete = contact;
      this.dialog = true;
    },

    async loadcontacts() {
      return await axios
        .get(
          "/contacto/contrato/" + this.contratoId + "/tipo/" + this.tipoContacto
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadDataContactos() {
      this.contactos = await this.loadcontacts();
    },
  },
};
</script>
